import React, { useEffect, useState } from 'react';

import Spinner from './Spinner';

// Witty, newsroom/print-themed lines that rotate while a content page is being fetched —
// a little personality for the wait, in the spirit of Discord's loading quips.
const MESSAGES = [
  'Fetching the latest scoop…',
  'Warming up the printing press…',
  'Chasing down the story…',
  'Interviewing the database…',
  'Checking our sources…',
  'Rolling the presses…',
  'Dusting off the archives…',
  'Proofreading every pixel…',
  'Waiting for the ink to dry…',
  'Holding the front page…',
  'Straightening the headlines…',
];

const ROTATE_MS = 2000;

const ContentLoader: React.FC = () => {
  // Start on a random line so a repeat visit doesn't always open the same way.
  const [index, setIndex] = useState(() => Math.floor(Math.random() * MESSAGES.length));

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return (): void => window.clearInterval(id);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-5 py-32 text-ink-muted">
      {/* Scoped in a local <style> so the keyframe needs no tailwind.config.js entry and
          can't bleed into the rest of the app.

          The fade collapses under `prefers-reduced-motion`, matching the system's rule that
          all three durations go to 1ms — the line still changes, it just stops sliding. */}
      <style>{`
        @keyframes contentLoaderFade {
          0%   { opacity: 0; transform: translateY(4px); }
          15%  { opacity: 1; transform: translateY(0); }
          85%  { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-4px); }
        }
        @media (prefers-reduced-motion: reduce) {
          .hub-loader-line { animation: none !important; }
        }
      `}</style>
      <Spinner size="lg" />
      {/* Re-mounting via key replays the fade each time the message changes. */}
      <span
        key={index}
        className="hub-loader-line font-display text-step-1 italic"
        style={{ animation: `contentLoaderFade ${ROTATE_MS}ms ease-in-out` }}
      >
        {MESSAGES[index]}
      </span>
    </div>
  );
};

export default ContentLoader;
